import Cookies from 'js-cookie';
import { getStoredTheme } from '../utils/theme';

export default {
  pagesize:20,
  breadcrumb:[],
  router:[],
  menu:[],
  menu_loaded:false,
  nickname:'',
  theme: getStoredTheme(),
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop'
}



// WEBPACK FOOTER //
// ./src/store/state.js